import tnoTrace from './tnoTrace'

const state = {
}

const getters = {
}

const mutations = {

}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    tnoTrace,
  }
}
